module.exports = __webpack_public_path__ + "img/select-empty-goods.1156bccd.png";